const CURBSIDE_PICKUP_ID = 'curbsideInfo';
const CURBSIDE = 'curbside';
const CURBSIDE_PICKUP = 'curbside-pickup';
const CURBSIDE_DETAILS = 'curbside-details';
const CURBSIDE_SUCCESS = 'curbside-success';
const CURBSIDE_ORDER_NOT_AVAILABLE = 'curbside-order status pickup not available';
const HERE_FOR_CURBSIDE = 'here for curbside';
const CURBSIDE_HOURS_CLOSED = 'hours closed';
const SHOW_PICKUP_BARCODE = 'show pickup barcode';

export {
    CURBSIDE_PICKUP_ID,
    CURBSIDE,
    CURBSIDE_PICKUP,
    CURBSIDE_DETAILS,
    CURBSIDE_SUCCESS,
    CURBSIDE_ORDER_NOT_AVAILABLE,
    HERE_FOR_CURBSIDE,
    CURBSIDE_HOURS_CLOSED,
    SHOW_PICKUP_BARCODE
};
